import { render, staticRenderFns } from "./CardComparison.vue?vue&type=template&id=9b0ccc50"
import script from "./CardComparison.vue?vue&type=script&lang=js"
export * from "./CardComparison.vue?vue&type=script&lang=js"
import style0 from "./CardComparison.vue?vue&type=style&index=0&id=9b0ccc50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports